import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import { persistAdminUser } from '../assets/utils/adminUserStorage'
import { clearImmediateLoadingAdminSession } from '../assets/utils/immediateLoadingAdminSession'
Vue.use(Vuex)

function restoreAdminUser (key) {
  const value = localStorage.getItem(key)
  if (!value) {
    return null
  }
  const sanitized = persistAdminUser(localStorage, key, value)
  return sanitized ? JSON.stringify(sanitized) : null
}

const storedSysUserInfo = restoreAdminUser('sysUserInfo')
const storedJgcSysUserInfo = restoreAdminUser('jgcSysUserInfo')

const state = {
  basePath: 'https://www.yisujia.cc\\source_py\\', // 'https://www.yishujia.cloud\\source_py\\'
  device: localStorage.getItem('device') ? localStorage.getItem('device') : null,
  jgcSysUserInfo: storedJgcSysUserInfo,
  // 注册用户登录信息
  sysUserInfo: storedSysUserInfo,
  // 若localSorage存在token，将值赋给Vuex.state.token
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
  // 菜单
  menuData: {
    list: [
      {
        index: 'orderManager',
        label: '订单管理',
        url: '/order',
        icon: 'el-icon-s-order',
        isOpen: false,
        children: [{
          index: 'order',
          label: '模型订单',
          url: '/order',
          icon: 'el-icon-folder'
        }, {
          index: 'orderUpload',
          label: '备份模型',
          url: '/orderUpload',
          icon: 'el-icon-folder'
        }, {
          index: 'orderPy',
          label: '排牙订单',
          url: '/orderPy',
          icon: 'el-icon-folder'
        }, {
          index: 'order2',
          label: '订单日历',
          url: '/order2',
          icon: 'el-icon-date'
        }, {
          index: 'checkOrder',
          label: '审核订单',
          url: '/checkOrder',
          icon: 'el-icon-help'
        }, {
          index: 'orderTotal',
          label: '订单统计',
          url: '/orderTotal',
          icon: 'el-icon-s-data'
        }, {
          index: 'kb',
          label: '数据看板',
          url: '/kb',
          icon: 'el-icon-finished'
        }, {
          index: 'hxOrder',
          label: '核销订单',
          url: '/hxOrder',
          icon: 'el-icon-s-operation'
        }]
      }, {
        index: 'deviceManager',
        label: '设备管理',
        url: '/device',
        icon: 'el-icon-printer',
        isOpen: false,
        children: [
          {
            index: 'device',
            label: '设备列表',
            url: '/device',
            icon: 'el-icon-takeaway-box'
          }, {
            index: 'lcd',
            label: 'lcd设备列表',
            url: '/lcd',
            icon: 'el-icon-takeaway-box'
          }, {
            index: 'deviceRun',
            label: '设备运行统计',
            url: '/deviceRun',
            icon: 'el-icon-data-line'
          }, {
            index: 'deviceRunDetial',
            label: '设备运行详情',
            url: '/deviceRunDetial',
            icon: 'el-icon-data-analysis'
          }, {
            index: 'websocket',
            label: '设备实时数据',
            url: '/websocket',
            icon: 'el-icon-receiving'
          }, {
            index: 'websocketTemp',
            label: '温湿度实时数据',
            url: '/websocketTemp',
            icon: 'el-icon-receiving'
          }
        ]
      }, {
        index: 'material',
        label: '材料管理',
        url: '/material',
        icon: 'el-icon-wallet',
        isOpen: false,
        children: [
          {
            index: 'material',
            label: '材料进出货管理',
            url: '/material',
            icon: 'el-icon-bank-card'
          }, {
            index: 'materialType',
            label: '材料类型管理',
            url: '/materialType',
            icon: 'el-icon-box'
          }
        ]
      }, {
        index: 'file',
        label: '模型管理',
        url: '/file',
        icon: 'el-icon-s-data'
      }, {
        index: 'fileManage',
        label: '文件管理',
        url: '/fileManage',
        icon: 'el-icon-coordinate'
      }, {
        index: 'registerManager',
        label: '用户管理',
        url: '/registerManager',
        icon: 'el-icon-s-custom',
        isOpen: false
      }, {
        index: 'registerPyManager',
        label: '排牙用户',
        url: '/registerPyManager',
        icon: 'el-icon-s-custom',
        isOpen: false
      }, {
        index: 'sysUserInfoManager',
        label: '系统管理',
        url: '/sysUserInfo',
        icon: 'el-icon-setting',
        isOpen: false,
        children: [{
          index: 'sysUserInfo',
          label: '系统用户',
          url: '/sysUserInfo',
          icon: 'el-icon-user'
        }, {
          index: 'sysRole',
          label: '角色管理',
          url: '/sysRole',
          icon: 'el-icon-coordinate'
        }, {
          index: 'msgInfo',
          label: '消息通知设置',
          url: '/msgInfo',
          icon: 'el-icon-coordinate'
        }, {
          index: 'log',
          label: '日志管理',
          url: '/log',
          icon: 'el-icon-document'
        }, {
          index: 'desktopRelease',
          label: '客户端版本管理',
          url: '/desktop-release',
          icon: 'el-icon-upload2',
          systemAdminOnly: true
        }]
      }
    ],
    collapse: false
  }
}

state.menuData.list.push({
  index: 'immediateLoadingManager',
  label: '即刻负重管理',
  url: '/immediate-loading/registrations',
  icon: 'el-icon-s-platform',
  isOpen: false,
  systemAdminOnly: true,
  children: [{ index: 'fullArchBilling', label: '全口充值与钱包', url: '/immediate-loading/fullarch-billing', icon: 'el-icon-wallet', systemAdminOnly: true }, ...['slice-tasks', 'devices', 'deliveries'].map((kind, index) => ({
    index: 'printAdmin' + index,
    label: ['切片任务', '设备管理', '发送记录'][index],
    url: '/immediate-loading/print/' + kind,
    icon: ['el-icon-files', 'el-icon-printer', 'el-icon-position'][index],
    systemAdminOnly: true
  })), {
    index: 'immediateLoadingRegistrations',
    label: '注册审核',
    url: '/immediate-loading/registrations',
    icon: 'el-icon-s-check',
    systemAdminOnly: true
  }, {
    index: 'immediateLoadingRedeem',
    label: '兑换码管理',
    url: '/immediate-loading/redeem',
    icon: 'el-icon-bank-card',
    systemAdminOnly: true
  }, {
    index: 'immediateLoadingUsers',
    label: '用户管理',
    url: '/immediate-loading/users',
    icon: 'el-icon-user',
    systemAdminOnly: true
  }, {
    index: 'immediateLoadingTasks',
    label: '任务管理',
    url: '/immediate-loading/tasks',
    icon: 'el-icon-s-order',
    systemAdminOnly: true
  }]
})

state.menuData.list.push({
  index: 'platformManager',
  label: '中台管理',
  url: '/platform/order',
  icon: 'el-icon-s-grid',
  isOpen: false,
  children: [{
    index: 'platformOrder',
    label: '中台订单',
    url: '/platform/order',
    icon: 'el-icon-s-order'
  }, {
    index: 'platformExceptionList',
    label: '异常列表',
    url: '/platform/exception-list',
    icon: 'el-icon-warning-outline'
  }, {
    index: 'platformExceptionStats',
    label: '异常统计',
    url: '/platform/exception-stats',
    icon: 'el-icon-data-analysis'
  }, {
    index: 'platformAuditLog',
    label: '审计日志',
    url: '/platform/audit-log',
    icon: 'el-icon-document'
  }, {
    index: 'platformSearch',
    label: '统一检索',
    url: '/platform/search',
    icon: 'el-icon-search'
  }, {
    index: 'platformAccountCache',
    label: '账号缓存',
    url: '/platform/account-cache',
    icon: 'el-icon-user'
  }, {
    index: 'platformUploadRule',
    label: '上传规则',
    url: '/platform/upload-rule',
    icon: 'el-icon-setting'
  }]
})

const mutations = {
  // 切换菜单状态
  switchCollapseMenu (state, value) {
    if (value != null) {
      state.menuData.collapse = value
    } else {
      state.menuData.collapse = !state.menuData.collapse
    }
    window.localStorage.setItem('MENU_STATUS', state.menuData.collapse)
  },
  // 设置已登录的用户信息
  setSysUserInfo (state, sysUserInfo) {
    state.sysUserInfo = persistAdminUser(localStorage, 'sysUserInfo', sysUserInfo)
  },
  setToken (state, token) {
    localStorage.setItem('token', token)

    const expirationDate = new Date().getTime() + 168 * 3600 * 1000 // 设置过期时间为7天
    localStorage.setItem('expirationDate', expirationDate)

    state.token = token
  },
  setJgcSysUserInfo (state, sysUserInfo) {
    state.setJgcSysUserInfo = persistAdminUser(localStorage, 'jgcSysUserInfo', sysUserInfo)
  },
  setDevice (state, device) {
    state.setDevice = device
    localStorage.setItem('device', JSON.stringify(device))
  },
  // 我页面中写了退出登录的按钮所以补了一个logout用来清空localStorage中的数据
  logout (state) {
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('sysUserInfo')
    state.sysUserInfo = null
    localStorage.removeItem('expirationDate')
    clearImmediateLoadingAdminSession()
  }
}
const actions = {}
const getters = {}
export default new Vuex.Store({
  modules,
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js